<template>
  <div>
    <!-- create dialog -->
    <dialogTemplate
      :openDialog="isOpen"
      :widthDialog="'1300px'"
      :classDialog="'createDialog'"
      :offsetTop="''"
      @closeDialog="$emit('closeDialog')"
      @closed="$emit('closed')"
    >
      <template #body>
        <div class="scanContainer">
          <h3 class="dialogTitle">Quét văn bản chờ tiếp nhận</h3>
          <div class="scanBody">
            <select id="sources"
                    class="input-font__bold input-border__bottom input-border__radius__0"></select>
            <el-button class="dialogBtnPrimary scan-button" @click="acquireImage()">
              <i :class="'fas fa-search'"></i>
              &nbsp;Scan
            </el-button>
            <el-button class="dialogBtnPrimary" @click="openImage()">
              <i :class="'fas fa-file-upload'"></i>
              &nbsp;Chọn
            </el-button>
            <el-button class="dialogBtnPrimary" @click="cleanDocument()">
              <i :class="'fas fa-backspace'"></i>
              &nbsp;Clean
            </el-button>
            <el-button class="dialogBtnPrimary" @click="upload()">
              <i :class="'fas fa-save'"></i>
              &nbsp;Lưu
            </el-button>
            <br/>
<!--            <el-form-item class="custom-label__input" prop="publisherId">-->
<!--             -->
<!--            </el-form-item>-->
            <div class="input-fix">
              <el-row :gutter="24">
                <el-col :span="18">
                  <el-form ref="form">
                    <el-form-item class="custom-label__input text-left">
                      <span class="label-input">Đơn vị ban hành </span>
                      <el-input
                        v-model="publisherName"
                        size="large"
                        class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                        :disabled="true"
                      />
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
            </div>

            <div class="documents">
              <el-table
                class="table detailRelatedDocs"
                style="width: 100%;"
                :data="documents"
                size=""
                v-if="documents && documents.length"
              >
                <el-table-column label="Trích yếu"  width="250" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="flex-row flex__left margin-right-10">
                    <span class="file-text-input style-fullWidth">
                    <el-input
                      class="style-fullWidth inputBg__white"
                      placeholder="-"
                      size="mini"
                      v-model="scope.row.quote"
                      :readonly="false"
                      maxlength="200"
                    ></el-input>
                  </span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Tên văn bản"
                  width="200"
                >
                  <template slot-scope="scope">
                    <el-input
                      size="mini"
                      v-model="scope.row.fileName"
                      placeholder="-"
                      class="style-fullWidth inputBg__white"
                      maxlength="100"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="Thời gian ký duyệt" width="180" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="flex-row flex__left margin-right-10">
                      <span class="file-text-input style-fullWidth">
                                <el-date-picker
                                  class="style-fullWidth inputBg__white"
                                  v-model="scope.row.signerTime"
                                  type="date"
                                  :prefix-icon="' '"
                                  placeholder="dd/mm/yyyy"
                                  format="dd/MM/yyyy"
                                ></el-date-picker>
                      </span>
                    </div>

                  </template>

                </el-table-column>
                <el-table-column label="Người ký duyệt" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="flex-row flex__left margin-right-10">
                      <span class="file-text-input style-fullWidth">
                        <el-select
                          filterable
                          class="style-fullWidth inputBg__white"
                          v-model="scope.row.signerUserDeptRoleId"
                        >
                      <el-option
                        v-for="item in signerUserDeptRoles"
                        :label="customLabel(item)"
                        :key="item.id"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                      </span>
                    </div>

                  </template>

                </el-table-column>
                <el-table-column label="Đơn vị thực hiện" width="250" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="flex-row flex__left margin-right-10">
                      <span class="file-text-input style-fullWidth">
                        <el-select
                          filterable
                          class="style-fullWidth inputBg__white"
                          v-model="scope.row.deptEditorId"
                        >
                      <el-option
                        v-for="item in editorDepartments"
                        :label="item.deptName"
                        :key="item.id"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                      </span>
                    </div>

                  </template>

                </el-table-column>



              </el-table>
            </div>


<!--            </div>-->
            <div class="content" v-bind:id="containerId"></div>

          </div>
        </div>


      </template>
      <template #footer>
      </template>
    </dialogTemplate>

  </div>
</template>

<script>

import Dynamsoft from "dwt";
import httpService from "../../services/httpService";
import {Loading} from 'element-ui';
import outgoingDocService from "../../services/outgoingDocService";
// import constants from "../../constants";
import departmentService from "../../services/departmentService";
import systemConfigService from "../../services/systemConfigService";
import userDeptRoleViewService from "../../services/userDeptRoleViewService";
import constants from "../../constants";


const path = require('path');


export default {
  name: "multi-scan-cho-ban-hanh-dialog",
  props: ["isOpen"],
  filters: {},
  components: {
    dialogTemplate: () => import("../common/custom-dialog.vue")
  },
  mounted() {
    this.initScanLib();
  },
  mixins: [],
  data() {
    return {
      departments:[],
      documents: [],
      option: null,
      options: [],
      containerId: "dwtControlContainer",
      bWASM: true,
      hasSource: false,
      aryIndicesTags: [],
      fileName: null,
      publisher: null,
      publisherName: null,
      publisherId: null,
      publisherDepartments: [],
      editorDepartments:[],
      signerUserDeptRoles:[],
      signerUserDeptRole:null,
    }
  },

  computed: {
    deptId() {
      return this.$store.getters.userDeptRole.deptId;
    }
  },

  created() {
    Promise.all([this.loadPublisherDepartments(), this.loadDepartments()]).then(
      () => {
        this.publisherName = this.publisher.deptName;
        this.initEditorDepartments();
      }
    );
    this.loadSignerUserDeptRoles();
    this.initScanFileName();
  },

  methods: {
    customLabel(item){
      return item.fullName + "("+item.positionName + " - " + item.deptName+")";
    },
    loadDepartments() {
      return departmentService
        .findAll({sort: "deptName,asc"})
        .then(response => {
          this.departments = response.data;
          this.prepareEditorDepartments(this.deptId);
        });
    },
    initEditorDepartments() {
      this.prepareEditorDepartments(this.deptId);
    },
    prepareEditorDepartments(publisherId) {
      return (this.editorDepartments = departmentService.prepareEditorDepartments(
        publisherId,
        this.departments
      ));
    },
    signerLabel(signer) {
      return `${signer.fullName} (${signer.positionName} - ${signer.deptName})`;
    },
    signerUserDeptRolesChanged(signer,item) {
      item.signerUserDeptRoleId=signer ? signer.id : null;
      this.$nextTick(() =>
        this.$refs.form.validateField("signerUserDeptRoleId")
      );
    },
    loadSignerUserDeptRoles() {
      return userDeptRoleViewService
        .findAllSignerForCreateKyNgoai(this.deptId, {
          sort: "createTime,desc"
        })
        .then(response => (this.signerUserDeptRoles = response.data));
    },
    initScanFileName() {
      systemConfigService.getScanFileName().then(
        (response) => {
          this.fileName = response.data;
        }
      );
    },
    cleanDocument() {
      this.publisherId = null;
      this.documents = [];
      this.aryIndicesTags = [];
      this.hasSource = false;
      this.initScanLib();
    },
    BinitScanFileName() {
      systemConfigService.getScanFileName().then(
        (response) => {
          this.fileName = response.data;
        }
      );
    },
    initScanLib() {
      this.bWASM = Dynamsoft.Lib.env.bMobile || Dynamsoft.WebTwainEnv.UseLocalService;
      console.log("bWASM", this.bWASM);
      /**
       * ResourcesPath & ProductKey must be set in order to use the library!
       */
      Dynamsoft.WebTwainEnv.ResourcesPath = path.join(__dirname, '../../../static/dwt-resources');
      // Dynamsoft.WebTwainEnv.ProductKey =
      //   "t0068MgAAAJCtoPQCHphc8EjbjXjN+mTlyo/8etwp3pdGjpb0sHLVJJM2GEqTIOSkeGoJsV8sYJ7tpdlNV+wcRzj9K4mybmo=";
      Dynamsoft.WebTwainEnv.ProductKey = constants.DYNAMIC_WEB_TWAIN_KEY;
      Dynamsoft.WebTwainEnv.Containers = [{
        WebTwainId: "dwtObject",
        ContainerId: this.containerId,
        Width: "1130px",
        Height: "1130px",
      },];
      Dynamsoft.WebTwainEnv.RegisterEvent("OnWebTwainReady", () => {
        this.Dynamsoft_OnReady();
      });
      Dynamsoft.WebTwainEnv.Load();
    },

    /**
     * Dynamsoft_OnReady is called when a WebTwain instance is ready to use.
     * In this callback we do some initialization.
     */
    Dynamsoft_OnReady() {
      console.log("Dynamsoft_OnReady");
      this.DWObject = Dynamsoft.WebTwainEnv.GetWebTwain(this.containerId);
      let sources = this.DWObject.GetSourceNames();
      for (let i = 0; i < sources.length; i++) {
        this.options.push({
          index: i,
          name: sources[i]
        })
      }
      this.selectSources = document.getElementById("sources");
      this.selectSources.options.length = 0;
      for (let i = 0; i < sources.length; i++) {
        this.selectSources.options.add(new Option(sources[i], i.toString()));
      }
    },
    /**
     * Acquire images from scanners or cameras or local files
     */
    acquireImage() {
      // if (!this.publisherId) {
      //   this.message("Thông báo", "Chưa chọn đơn vị ban hành", "warning", 2000);
      //   return;
      // }
      if (!this.DWObject) this.DWObject = Dynamsoft.WebTwainEnv.GetWebTwain();
      else if (
        this.DWObject.SourceCount > 0 &&
        this.DWObject.SelectSourceByIndex(this.selectSources.selectedIndex)
      ) {
        const onAcquireImageSuccess = () => {
          this.DWObject.CloseSource();
          this.tagDocument();
          // console.log(this.DWObject.ErrorString);
        };
        const onAcquireImageFailure = onAcquireImageSuccess;
        this.DWObject.OpenSource();
        this.DWObject.AcquireImage({},
          onAcquireImageSuccess,
          onAcquireImageFailure
        );
        this.hasSource = true;
      } else {
        this.hasSource = false;
        alert("No Source Available!");
      }
    },
    /**
     * Open local images.
     */
    openImage() {

      // if (!this.publisherId) {
      //   this.message("Thông báo", "Chưa chọn đơn vị ban hành", "warning", 2000);
      //   return;
      // }
      if (!this.DWObject) this.DWObject = Dynamsoft.WebTwainEnv.GetWebTwain();
      this.DWObject.IfShowFileDialog = true;
      /**
       * Note, this following line of code uses the PDF Rasterizer which is an extra add-on that is licensed seperately
       */
      this.DWObject.Addon.PDF.SetConvertMode(
        Dynamsoft.EnumDWT_ConvertMode.CM_RENDERALL
      );

      this.DWObject.LoadImageEx(
        "",
        Dynamsoft.EnumDWT_ImageType.IT_ALL,
        () => {
          this.hasSource = true;
          this.tagDocument();
          //success
        },
        () => {
          //failure
          this.hasSource = false;
        }
      );

    },

    tagDocument() {
      console.log("tagDocument");
      let count = 0;
      let aryIndice = [];
      this.aryIndicesTags=[];
      this.documents = [];
      for (let i = 0; i < this.DWObject.HowManyImagesInBuffer; i++) {
        if (this.DWObject.IsBlankImage(i)) {
          if (i != 0) {
            this.aryIndicesTags.push(aryIndice);
            this.documents.push({
              quote: this.fileName + "_" + count,
              fileName: this.fileName + "_" + count,
              signerTime: new Date(),
              signerUserDeptRoleId: (this.signerUserDeptRoles&&this.signerUserDeptRoles.length>0)?this.signerUserDeptRoles[0].id:null,
              deptId: this.deptId,
              deptEditorId: (this.editorDepartments&&this.editorDepartments.length>0)?this.editorDepartments[0].id:null,
              publisherId: this.deptId,

            })
          }
          aryIndice = [];
          count++;
        } else {
          aryIndice.push(i);
        }
      }
      this.aryIndicesTags.push(aryIndice);
      this.documents.push({
        quote: this.fileName + "_" + count,
        fileName: this.fileName + "_" + count,
        signerTime: new Date(),
        signerUserDeptRoleId: (this.signerUserDeptRoles&&this.signerUserDeptRoles.length>0)?this.signerUserDeptRoles[0].id:null,
        deptId: this.deptId,
        deptEditorId: (this.editorDepartments&&this.editorDepartments.length>0)?this.editorDepartments[0].id:null,
        publisherId: this.deptId
      })

    },
    upload() {
      let count = 0;
      if (this.aryIndicesTags.length <= 0) {
        this.message("Thông báo", "Chưa tìm thấy văn bản scan", "warning", 2000);
        return;
      }
      let loadingInstance = Loading.service({});
      for (let i = 0; i < this.aryIndicesTags.length; i++) {
        this.DWObject.ConvertToBlob(this.aryIndicesTags[i], Dynamsoft.EnumDWT_ImageType.IT_PDF, (_blob, newIndices, enumImageType, _arguments) => {
            let fd = new FormData();
            fd.append('file', _blob);
            fd.append('objectType', 2);
            fd.append('fileName', this.documents[i].fileName + ".pdf");
            httpService.post('attachment/uploadFileScanFile', fd).then((response) => {
              this.documents[i].attachIds = [response.data.id];
              count++;
            }).then(() => {
              if ((count == (this.documents.length)) && (count == (this.aryIndicesTags.length))) {
                outgoingDocService
                  .createOutgoingDocKyNgoaiByScan(this.documents).then((response) => {
                  loadingInstance.close();
                  this.$emit("success");

                }).catch(() => {
                  loadingInstance.close();
                })

              }
            })
          }, (error) => {
            loadingInstance.close();
            console.log(error);
          }
        );
      }

    },
    loadPublisherDepartments() {
      return departmentService
        .findById(this.deptId)
        .then(response => (this.publisher = response.data));
    },
    cancel() {
      this.$emit("closeDialog");
    },
    success() {
      this.$emit("success");
    }
  }
}


</script>

<style scoped>
.content {
  height: 300px;
}

.scanContainer {
  height: 850px;
}

.scanBody {
  padding-bottom: 20px;
}

#sources {
  height: 35px;
  border: 1px solid #7a7a7f;
  border-radius: 1px;
}
.input-fix{
  margin-top: 10px;
}
.scan-button{
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/multi-scan-cho-ban-hanh-dialog.vue